import React from 'react';

const Divider = () => {

    return (
        <div className="border-b border-b-gray-600 w-full pt-2 md:pt-4"></div>
    )
};

export default Divider;